// Simple cache: in-memory (instant for tab switches) + localStorage (persists across page loads)
// TTLs are short enough to stay fresh, long enough to avoid redundant API calls.

const MEM = {};
const LS_PREFIX = 'axcache_';

function get(key) {
  // Check memory first
  const mem = MEM[key];
  if (mem && Date.now() < mem.exp) return mem.data;

  // Fall back to localStorage
  try {
    const raw = localStorage.getItem(LS_PREFIX + key);
    if (raw) {
      const item = JSON.parse(raw);
      if (Date.now() < item.exp) {
        MEM[key] = item; // warm memory cache
        return item.data;
      }
      localStorage.removeItem(LS_PREFIX + key);
    }
  } catch {}
  return null;
}

function set(key, data, ttlMs) {
  const item = { data, exp: Date.now() + ttlMs };
  MEM[key] = item;
  try { localStorage.setItem(LS_PREFIX + key, JSON.stringify(item)); } catch {}
}

// Bust all keys that start with prefix (e.g. 'finance_' after an upload)
function invalidate(prefix) {
  Object.keys(MEM).forEach(k => { if (k.startsWith(prefix)) delete MEM[k]; });
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith(LS_PREFIX + prefix))
      .forEach(k => localStorage.removeItem(k));
  } catch {}
}

const TTL = {
  SHORT:  60 * 1000,          // 1 min  — conversations list
  MEDIUM: 5  * 60 * 1000,     // 5 min  — profile, health score, reviews
  LONG:   15 * 60 * 1000,     // 15 min — tax estimate, alerts (rarely change)
};

export { get, set, invalidate, TTL };
